import React from 'react';

import { Alert, Flex, Typography } from 'antd';

import { getResponseErrors } from '@app/services/apiErrors';
import { useApiErrorMessage } from '@app/services/hooks/useApiErrorMessage';
import { EpdIssues } from '@components/EpdIssues';

interface IProps {
  error: unknown;
}

export const EpdError: React.FC<IProps> = ({ error }) => {
  const getErrorMessage = useApiErrorMessage();
  const errors = getResponseErrors(error);
  return (
    <Alert
      type="error"
      showIcon
      title={getErrorMessage(error)}
      description={
        <Flex vertical gap={8}>
          {errors.map((item, index) => (
            <React.Fragment key={index}>
              {item.detail && <Typography.Text>{item.detail}</Typography.Text>}
              {!!item.meta?.issues?.length && <EpdIssues issues={item.meta.issues} />}
              {!item.detail &&
                item.meta?.problems?.map((problem, position) => (
                  <Typography.Text key={position}>{problem}</Typography.Text>
                ))}
            </React.Fragment>
          ))}
        </Flex>
      }
    />
  );
};
